import { useClient } from '@composables/use-clients';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';
import { DEFAULTS } from '@constants/defaults';

export const apiFetchCurrentUserTenants = async ({
  query = {
    page: DEFAULTS.API.QUERY.PAGE,
    pageSize: DEFAULTS.API.QUERY.FLEX_LIST_PAGE_SIZE - 1,
  },
  errorConfig = {},
  callbacks = {},
} = {}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({ url: urls.v1.currentUserTenants(), query });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
